import request from './request';

const statisticService = {
  getAll: (params) => request.get('dashboard/admin/statistics', { params }),
  summary: (params) => request.get('dashboard/admin/summary', { params }),
  topCustomers: (params) =>
    request.get(`dashboard/admin/statistics/users`, { params }),
  topProducts: (params) =>
    request.get(`dashboard/admin/statistics/products`, { params }),
  ordersCount: (params) =>
    request.get(`dashboard/admin/statistics/orders/chart`, { params }),
};

export default statisticService;
